import React, { useRef } from 'react'
import { useDispatch } from 'react-redux';
import formStyles from '../Forms/Form.module.scss'
import { doImportLayout } from '../store/actions/channelLayout';

export default function() {
  const dispatch = useDispatch();
  const raw_layout = useRef<HTMLTextAreaElement>(null);

  return (
    <div className={formStyles.formsWrapper}>
      <form className={formStyles.settingsForm}>
        <fieldset>
          <legend>Channel Layout</legend>
          <label>
            <textarea ref={raw_layout}></textarea>
          </label>
          <label><input className={formStyles.labelButton} type="button" value="Load Layout" onClick={() => dispatch(doImportLayout(raw_layout?.current?.value??""))} /></label>
        </fieldset>
      </form>
    </div>
  );
}